module.exports = __webpack_public_path__ + "img/sit.be5030ca.webp";